export { default as AxiosPlugin } from './axios';
export { default as DatePlugin } from './date';
export { default as DisplayPlugin } from './displays';
export { default as LodashPlugin } from './lodash';
export { default as SafeHtml } from './safeHtml';
export * from './vuetify';
export { default as WebPlugin } from './web';
